import { Component, Input } from "@angular/core";

@Component({
  selector: "app-demande-service-steps",
  templateUrl: "./demande-service-steps.component.html",
  styleUrls: ["./demande-service-steps.component.scss"],
})
export class DemandeServiceStepsComponent {
  @Input() leftLabel = "";
  @Input() rightLabel = "";
}
